/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ic_user': {
    width: 44,
    height: 44,
    viewBox: '0 0 44 44',
    data: '<g clip-path="url(#clip0)" fill-rule="evenodd" clip-rule="evenodd" _fill="#5F01D3"><path pid="0" d="M2.685 28.352a9.167 9.167 0 016.482-2.685H22a9.166 9.166 0 019.167 9.166V38.5a1.833 1.833 0 01-3.667 0v-3.667a5.5 5.5 0 00-5.5-5.5H9.167a5.5 5.5 0 00-5.5 5.5V38.5A1.833 1.833 0 010 38.5v-3.667c0-2.43.966-4.762 2.685-6.481zM15.583 7.333a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm-9.166 5.5a9.167 9.167 0 1118.333 0 9.167 9.167 0 01-18.333 0zM43.463 15.204a1.834 1.834 0 010 2.592L36.13 25.13a1.833 1.833 0 01-2.593 0l-3.667-3.667a1.833 1.833 0 012.593-2.593l2.37 2.37 6.037-6.036a1.834 1.834 0 012.593 0z"/></g><defs><clipPath id="clip0"><path pid="1" _fill="#fff" d="M0 0h44v44H0z"/></clipPath></defs>'
  }
})
